<template>
  <div
    :class="
      mainHeader
        ? 'h-9 flex justify-center items-center space-x-2'
        : 'logo space-x-2'
    "
  >
    <div
      v-if="loading"
      :class="{ 'spinner-wrapper flex items-center justify-center': loading }"
    >
      <ion-spinner name="bubbles" size="large" class="custom-spinner" />
    </div>
    <svg
      v-else-if="isDev && !login"
      width="40"
      height="41"
      viewBox="0 0 1024 1024"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6_9915)">
        <rect width="1024" height="1024" rx="100" fill="#E50038" />
        <path d="M0 0H1024L0 1024V0Z" fill="#2B2B2B" />
        <g filter="url(#filter0_d_6_9915)">
          <path
            d="M442 582V511.58H582.14C620.64 511.58 652 480.36 652 441.72C652 403.22 620.78 371.86 582.14 371.86H162C162 255.94 256.08 162 372 162H582C736.7 162 862 287.3 862 442C862 596.7 736.7 722 582 722C504.72 722 442 659.28 442 582ZM372 652V442C256.08 442 162 535.94 162 652V862C277.92 862 372 767.92 372 652Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_6_9915"
          x="12"
          y="87"
          width="1000"
          height="1000"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="75" />
          <feGaussianBlur stdDeviation="75" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.203922 0 0 0 0 0.25098 0 0 0 0 0.329412 0 0 0 0.14 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6_9915"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6_9915"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_6_9915"></clipPath>
      </defs>
    </svg>
    <svg
      v-else-if="!login"
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_985_29352)">
        <path
          d="M0 12.5C0 5.87258 5.37258 0.5 12 0.5H28C34.6274 0.5 40 5.87258 40 12.5V28.5C40 35.1274 34.6274 40.5 28 40.5H12C5.37258 40.5 0 35.1274 0 28.5V12.5Z"
          fill="#E50038"
        />
        <path
          d="M17.6 22.9V20.4856H22.4048C23.7248 20.4856 24.8 19.4152 24.8 18.0904C24.8 16.7704 23.7296 15.6952 22.4048 15.6952H8C8 11.7256 11.2256 8.5 15.2 8.5H22.4C27.704 8.5 32 12.796 32 18.1C32 23.404 27.704 27.7 22.4 27.7C19.7504 27.7 17.6 25.5496 17.6 22.9ZM15.2 25.3V18.1C11.2256 18.1 8 21.3256 8 25.3V32.5C11.9744 32.5 15.2 29.2744 15.2 25.3Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_985_29352">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-if="(!searchClicked && mainHeader) || login"
      :class="loading ? 'animate-pulse' : ''"
      width="104.25"
      height="27.75"
      viewBox="0 0 1112 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1092.37 99.6206C1093.49 99.0006 1094.42 98.1327 1095.16 97.0167C1095.91 95.9008 1096.28 94.5369 1096.28 92.987C1096.28 91.4371 1095.91 90.1352 1095.22 89.0812C1094.48 88.0273 1093.61 87.2213 1092.5 86.6634C1091.38 86.1054 1090.26 85.8574 1089.15 85.8574H1078.18V108.734H1082.21V100.489H1088.53L1092.81 108.734H1097.27L1092.37 99.6206ZM1082.14 88.9572H1087.91C1088.9 88.9572 1089.83 89.2672 1090.64 89.8872C1091.5 90.5072 1091.88 91.5611 1091.88 92.987C1091.88 94.4129 1091.44 95.4668 1090.64 96.2108C1089.77 96.9547 1088.84 97.3267 1087.79 97.3267H1082.08V88.8952L1082.14 88.9572Z"
        fill="#E50038"
      />
      <path
        d="M1109.48 87.9684C1108.18 84.9926 1106.45 82.3267 1104.15 80.0329C1101.86 77.739 1099.25 76.0031 1096.22 74.7012C1093.24 73.3993 1090.02 72.7793 1086.55 72.7793C1083.07 72.7793 1079.91 73.3993 1076.87 74.7012C1073.9 76.0031 1071.23 77.739 1068.94 80.0329C1066.64 82.3267 1064.91 84.9306 1063.61 87.9684C1062.3 90.9442 1061.68 94.168 1061.68 97.6398C1061.68 101.112 1062.3 104.273 1063.61 107.311C1064.91 110.287 1066.64 112.953 1068.94 115.247C1071.23 117.541 1073.84 119.277 1076.87 120.578C1079.91 121.88 1083.07 122.5 1086.55 122.5C1090.02 122.5 1093.18 121.88 1096.22 120.578C1099.19 119.277 1101.86 117.541 1104.15 115.247C1106.45 112.953 1108.18 110.349 1109.48 107.311C1110.79 104.335 1111.41 101.112 1111.41 97.6398C1111.41 94.168 1110.79 91.0062 1109.48 87.9684ZM1104.03 107.807C1102.23 110.845 1099.75 113.325 1096.71 115.123C1093.67 116.921 1090.26 117.851 1086.55 117.851C1082.83 117.851 1079.42 116.921 1076.38 115.123C1073.34 113.325 1070.86 110.845 1069.06 107.807C1067.26 104.769 1066.33 101.36 1066.33 97.6398C1066.33 93.92 1067.26 90.5102 1069.06 87.4724C1070.86 84.4346 1073.34 81.9547 1076.38 80.1568C1079.42 78.359 1082.83 77.429 1086.55 77.429C1090.26 77.429 1093.67 78.359 1096.71 80.1568C1099.75 81.9547 1102.23 84.4346 1104.03 87.4724C1105.83 90.5102 1106.76 93.92 1106.76 97.6398C1106.76 101.36 1105.83 104.769 1104.03 107.807Z"
        fill="#E50038"
      />
      <path
        d="M293.914 297.522C279.902 297.522 267.441 295.042 256.468 290.144C245.494 285.246 236.877 277.931 230.491 268.259C224.168 258.588 221.006 246.499 221.006 231.992C221.006 219.778 223.238 209.549 227.701 201.241C232.165 192.934 238.303 186.3 245.99 181.217C253.74 176.195 262.481 172.351 272.401 169.809C282.258 167.206 292.612 165.408 303.523 164.354C316.294 163.052 326.586 161.75 334.397 160.572C342.209 159.394 347.912 157.596 351.384 155.24C354.856 152.884 356.654 149.351 356.654 144.639V143.771C356.654 134.719 353.802 127.714 348.16 122.754C342.519 117.794 334.459 115.315 324.044 115.315C313.07 115.315 304.329 117.732 297.881 122.506C292.984 126.164 289.326 130.504 286.908 135.525C285.482 138.501 282.506 140.361 279.22 140.113L237.993 136.765C232.971 136.331 229.623 131.31 231.235 126.536C234.397 117.113 239.171 108.743 245.494 101.365C253.864 91.5701 264.713 84.0685 278.042 78.7988C291.31 73.5291 306.747 70.8633 324.292 70.8633C336.505 70.8633 348.222 72.2892 359.382 75.141C370.603 77.9929 380.522 82.4566 389.264 88.4702C398.005 94.4839 404.887 102.171 409.909 111.533C414.93 120.894 417.472 132.178 417.472 145.197V266.462C417.472 281.341 405.445 293.368 390.566 293.368H367.441C363.163 293.368 359.692 289.896 359.692 285.618V262.928H357.956C354.422 269.809 349.71 275.823 343.82 281.031C337.931 286.238 330.801 290.268 322.494 293.182C314.186 296.096 304.639 297.522 293.728 297.522H293.914ZM311.334 255.488C320.262 255.488 328.197 253.69 335.079 250.157C341.961 246.623 347.354 241.725 351.26 235.649C355.166 229.574 357.15 222.63 357.15 214.943V191.632C355.228 192.872 352.624 193.988 349.338 194.98C346.052 195.972 342.333 196.902 338.241 197.708C334.149 198.514 330.057 199.258 325.966 199.878C321.874 200.498 318.154 201.055 314.806 201.489C307.677 202.543 301.415 204.217 296.083 206.511C290.752 208.805 286.598 211.843 283.622 215.749C280.646 219.654 279.22 224.366 279.22 230.132C279.22 238.439 282.258 244.763 288.272 249.103C294.348 253.442 302.035 255.612 311.396 255.612L311.334 255.488Z"
        fill="#E50038"
      />
      <path
        d="M652.81 53.8154V285.681C652.81 289.897 649.4 293.369 645.122 293.369H603.027C598.811 293.369 595.401 289.959 595.339 285.805L591.991 8.12409C591.991 3.97034 595.339 0.560547 599.493 0.560547C628.941 0.560547 652.81 24.4291 652.81 53.8774V53.8154Z"
        fill="#E50038"
      />
      <path
        d="M872.095 199.135C877.675 199.135 882.201 194.609 882.201 189.03V182.396C882.201 163.735 879.597 147.368 874.327 133.419C869.058 119.47 861.742 107.877 852.38 98.5771C843.019 89.3396 832.046 82.396 819.523 77.7463C806.999 73.0966 793.484 70.8027 778.977 70.8027C757.402 70.8027 738.679 75.5765 722.684 85.1239C706.689 94.6713 694.352 107.939 685.549 124.987C676.807 142.036 672.405 161.875 672.405 184.442C672.405 207.009 676.807 227.653 685.549 244.578C694.29 261.503 706.813 274.585 723.056 283.76C739.299 292.935 758.704 297.585 781.333 297.585C799.436 297.585 815.431 294.795 829.318 289.216C843.205 283.636 854.55 275.824 863.354 265.781C868.624 259.767 872.777 253.196 875.939 245.942C879.101 238.689 873.893 229.947 865.71 229.389L832.48 227.219C828.016 226.909 823.8 229.141 821.506 232.985C819.77 235.837 817.725 238.441 815.369 240.735C811.339 244.516 806.565 247.43 800.924 249.29C795.282 251.212 789.082 252.142 782.325 252.142C772.095 252.142 763.292 249.972 755.852 245.694C748.413 241.416 742.647 235.279 738.617 227.405C734.588 219.47 732.542 210.108 732.542 199.259V199.135H872.033H872.095ZM755.418 122.694C762.486 118.478 770.669 116.308 779.969 116.308C789.268 116.308 796.646 118.23 803.341 122.074C810.037 125.917 815.307 131.249 819.15 138.007C822.932 144.764 824.854 152.514 824.854 161.317H732.79C733.162 153.444 735.084 146.19 738.803 139.681C742.833 132.551 748.351 126.909 755.48 122.694H755.418Z"
        fill="#E50038"
      />
      <path
        d="M7.62552 299.938C37.3837 299.938 61.5003 275.821 61.5003 246.063V54.3707H107.998C143.769 54.3707 161.934 68.4439 161.934 96.2182C161.934 123.993 143.769 138.066 107.998 138.066H86.9808C86.1748 138.066 85.3689 138.19 84.5629 138.438C81.1531 139.616 79.1692 142.777 79.3552 146.063C80.7191 172.784 103.162 190.701 135.276 190.701C150.155 190.701 165.344 186.919 179.169 179.789C207.068 165.344 223.745 134.098 223.745 96.2182C223.745 36.8878 180.161 0 110.105 0H40.7316C18.2269 0 0 18.2269 0 40.7316V292.374C0 296.59 3.40977 300 7.62552 300V299.938Z"
        fill="#E50038"
      />
      <path
        d="M471.788 86.488C471.292 86.798 470.858 87.046 470.362 87.356C469.308 88.1 468.254 88.8439 467.2 89.6499C466.518 90.1458 465.898 90.6418 465.216 91.1378C464.287 91.8817 463.419 92.6877 462.551 93.4316C461.869 94.0516 461.125 94.6716 460.443 95.3535C459.637 96.1595 458.893 96.9654 458.087 97.7714C457.405 98.5153 456.661 99.3213 455.979 100.065C455.297 100.871 454.615 101.739 453.933 102.669C453.251 103.537 452.631 104.467 451.949 105.397C451.329 106.265 450.771 107.195 450.151 108.125C449.531 109.117 448.911 110.171 448.353 111.225C447.858 112.155 447.3 113.146 446.866 114.138C446.308 115.316 445.812 116.494 445.316 117.672C444.882 118.664 444.448 119.718 444.076 120.772C443.58 122.074 443.146 123.438 442.774 124.802C442.464 125.856 442.092 126.91 441.844 128.026C441.472 129.513 441.162 131.125 440.79 132.675C440.542 133.729 440.294 134.783 440.108 135.899C439.798 137.697 439.612 139.619 439.426 141.541C439.302 142.533 439.178 143.463 439.116 144.455C438.868 147.43 438.744 150.468 438.744 153.692L442.092 285.806C442.216 289.96 445.626 293.308 449.779 293.308H495.285C499.624 293.308 503.096 289.712 502.972 285.434L499.686 169.067C499.686 160.14 501.732 152.204 505.762 145.323C509.792 138.441 515.371 133.109 522.377 129.265C529.383 125.422 537.38 123.5 546.308 123.5C550.523 123.5 555.111 123.81 560.195 124.492C560.815 124.554 561.435 124.678 561.993 124.74C567.324 125.484 572.036 121.392 572.036 115.998V80.4124C572.036 75.9487 568.688 72.1669 564.287 71.6089C546.68 69.5011 502.662 66.7112 471.788 86.488Z"
        fill="#E50038"
      />
      <path
        d="M938.989 86.488C938.493 86.798 938.059 87.046 937.563 87.356C936.51 88.1 935.456 88.8439 934.402 89.6499C933.72 90.1458 933.1 90.6418 932.418 91.1378C931.488 91.8817 930.62 92.6877 929.752 93.4316C929.07 94.0516 928.326 94.6716 927.644 95.3535C926.838 96.1595 926.094 96.9654 925.288 97.7714C924.606 98.5153 923.862 99.3213 923.18 100.065C922.498 100.871 921.816 101.739 921.134 102.669C920.453 103.537 919.833 104.467 919.151 105.397C918.531 106.265 917.973 107.195 917.353 108.125C916.733 109.117 916.113 110.171 915.555 111.225C915.059 112.155 914.501 113.146 914.067 114.138C913.509 115.316 913.013 116.494 912.517 117.672C912.083 118.664 911.649 119.718 911.277 120.772C910.781 122.074 910.347 123.438 909.975 124.802C909.665 125.856 909.293 126.91 909.045 128.026C908.673 129.513 908.363 131.125 907.991 132.675C907.743 133.729 907.495 134.783 907.309 135.899C906.999 137.697 906.813 139.619 906.627 141.541C906.503 142.533 906.379 143.463 906.317 144.455C906.069 147.43 905.945 150.468 905.945 153.692L909.293 285.806C909.417 289.96 912.827 293.308 916.981 293.308H962.486C966.826 293.308 970.297 289.712 970.173 285.434L966.888 169.067C966.888 160.14 968.934 152.204 972.963 145.323C976.993 138.441 982.573 133.109 989.578 129.265C996.584 125.422 1004.58 123.5 1013.51 123.5C1017.72 123.5 1022.31 123.81 1027.4 124.492C1028.02 124.554 1028.64 124.678 1029.19 124.74C1034.53 125.484 1039.24 121.392 1039.24 115.998V80.4124C1039.24 75.9487 1035.89 72.1669 1031.49 71.6089C1013.88 69.5011 969.863 66.7112 938.989 86.488Z"
        fill="#E50038"
      />
    </svg>
  </div>
</template>
<script setup>
import { computed, ref, onMounted, onUnmounted, watch } from "vue";
import { IonSpinner } from "@ionic/vue";
import { useGlobalStore } from "@/stores/global";

defineProps({
  searchClicked: {
    type: Boolean,
    default: false,
  },
  mainHeader: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  login: {
    type: Boolean,
    default: false,
  },
});

const globalStore = useGlobalStore();

const isDev = import.meta.env.VITE_DEV;

const gradientId1 = ref("SVGID_1_");

onMounted(() => {
  gradientId1.value = "SVGID_" + Math.random().toString(36).substr(2, 9);
});

onUnmounted(() => {
  gradientId1.value = "SVGID_1_";
});
const getCssVariable = (variable) => {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(variable)
    .trim();
};

const primaryColor = computed(() => {
  return globalStore.primary_colors ?? getCssVariable("--primary-color");
});

const secondaryColor = computed(() => {
  return globalStore.secondary_colors ?? getCssVariable("--secondary-color");
});

watch(
  () => {
    return globalStore.primary_colors;
  },
  () => {
    primaryColor.value = globalStore.primary_colors;
  }
);

watch(
  () => {
    return globalStore.secondary_colors;
  },
  () => {
    secondaryColor.value = globalStore.secondary_colors;
  }
);
</script>

<style scoped>
.logo svg {
  width: 100%;
  /* or any other size */
  height: auto;
  max-width: 150px;
  /* or any other max size */
}

.spinner-wrapper {
  /* Center the spinner vertically */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
}

ion-spinner {
  --color: #e50038;
  --height: 41px;
}
</style>
